import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouterLegacy } from 'core/routerUtils';
import { withTranslation } from 'react-i18next';
import * as userActions from 'core/duck';
import { UsersService } from 'shared/services';
import { SuccessScreen } from 'shared/components';
import { parseQueryString } from 'shared/helpers';
import PasswordReset from './PasswordReset';
import NewPassword from './NewPassword';

const successData = {
  copy: 'resetPassword.passwordResetCopy',
  buttonLabel: 'common.labels.continueToSignIn',
  link: '/login',
  reloadLinkPage: true,
};

const resetEmailSent = (email, t) => ({
  copy: t('resetPassword.validationCodeMessage', { email }),
  buttonLabel: 'common.labels.continueToSignIn',
  link: '/login',
});

class ResetContainer extends Component {
  constructor(props) {
    super(props);

    const searchParams = parseQueryString(props.location.search);
    const resetEmail = searchParams.username;

    this.state = {
      submitted: false,
      validEmail: false,
      errorValidation: '',
      resetEmail,
    };
    this.onSubmitNew = this.onSubmitNew.bind(this);
    this.onSubmitReset = this.onSubmitReset.bind(this);
  }

  onSubmitNew(pass, verifCode) {
    const { resetEmail } = this.state;
    UsersService.completeForgotPassword({
      username: resetEmail,
      verificationCode: verifCode,
      newPassword: pass,
    })
      .then(() => {
        successData.copy = 'resetPassword.successResetCopy';
        this.setState({
          validEmail: false,
          submitted: true,
        });
      })
      .catch((error) => {
        this.setState({
          errorValidation: error.data.Error,
        });
      });
  }

  onSubmitReset(email) {
    this.setState({
      validEmail: true,
      email,
    });
  }

  render() {
    const { validEmail, email, submitted, resetEmail } = this.state;

    const getComponent = () => {
      if (this.state.submitted || this.state.validEmail) {
        return null;
      }

      return resetEmail ? (
        <NewPassword
          onSubmit={this.onSubmitNew}
          error={this.state.errorValidation}
          email={resetEmail}
        />
      ) : (
        <PasswordReset onSubmit={this.onSubmitReset} />
      );
    };
    return (
      <div className="reset-password">
        {getComponent()}
        {validEmail && <SuccessScreen data={resetEmailSent(email, this.props.t)} />}
        {submitted && <SuccessScreen data={successData} />}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.users.currentUser,
  };
}

function mapDispatchToProps(dispatch) {
  return { actions: bindActionCreators(userActions, dispatch) };
}

export default withTranslation()(
  withRouterLegacy(connect(mapStateToProps, mapDispatchToProps)(ResetContainer))
);

ResetContainer.propTypes = {
  // Props from react-router (via withRouterLegacy)
  location: PropTypes.shape({
    search: PropTypes.string,
  }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      hash: PropTypes.string,
    }).isRequired,
  }).isRequired,

  // Props from mapStateToProps
  user: PropTypes.shape({
    id: PropTypes.string,
  }),

  // Props from mapDispatchToProps
  actions: PropTypes.shape({
    updateUserInfo: PropTypes.func.isRequired,
    updateForgotPassword: PropTypes.func.isRequired,
  }).isRequired,
  t: PropTypes.func.isRequired,
};

ResetContainer.defaultProps = {
  user: {},
};
